import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import CourseList from './pages/CourseList';
import CourseDetails from './pages/CourseDetails';
import Subjects from './pages/Subjects';
import SubjectCategory from './pages/SubjectCategory';
import SubjectSubCategory from './pages/SubjectSubCategory';
import CourseVideos from './pages/CourseVideos';
import VideoPlayer from './pages/VideoPlayer';
import MyPurchased from './pages/MyPurchased';

// Styles
import './App.css';
import 'react-toastify/dist/ReactToastify.css';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <div className="app">
            <Header />
            <main className="main-content">
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/courses" element={<CourseList />} />
                <Route path="/course/:courseId" element={<CourseDetails />} />
                <Route path="/subjects/:courseId" element={<Subjects />} />
                <Route path="/subject-category/:courseId" element={<SubjectCategory />} />
                <Route path="/subject-subcategory/:subjectId" element={<SubjectSubCategory />} />
                <Route path="/videos/:subjectId" element={<CourseVideos />} />
                <Route path="/course-videos/:subjectId/:type" element={<CourseVideos />} />
                <Route path="/video-player/:videoId" element={<VideoPlayer />} />
                
                {/* Protected Routes */}
                <Route 
                  path="/my-purchased" 
                  element={
                    <ProtectedRoute>
                      <MyPurchased />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/profile" 
                  element={
                    <ProtectedRoute>
                      <div style={{ padding: '50px', textAlign: 'center' }}>
                        <h2>Profile Page - Coming Soon</h2>
                      </div>
                    </ProtectedRoute>
                  } 
                />
                
                {/* 404 */}
                <Route 
                  path="*" 
                  element={
                    <div style={{ padding: '100px', textAlign: 'center' }}>
                      <h1>404 - Page Not Found</h1>
                      <a href="/">Go to Home</a>
                    </div>
                  } 
                />
              </Routes>
            </main>
            <Footer />
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;

